import Masonry from './Masonry';

export default Masonry;